import { Form, Formik } from "formik";
import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import { t } from "../../../i18n/util";
import { hrStore } from "../../../stores/HrStore";
import { IPostApplicationStateTransitionPayload } from "../../../types/models";
import { FileError } from "../../application/DataUploadForm";
import { FormButtons, HrBotErrorMessage } from "../../ui/Primitives";
import { UploadField } from "../../ui/UploadField";
import { fileErrorToString } from "../../util/helpers";

type Props = {
    onSubmit: (model: IPostApplicationStateTransitionPayload) => void;
    onBack: () => void;
};

export const KanbanTransferAcceptDialog = ({ onSubmit, onBack }: Props) => {
    const [addFieldFileErrors, setAddFieldFileErrors] = React.useState<FileError[]>([]);

    return (
        <Formik
            initialValues={hrStore.currentDialogForm}
            onSubmit={(model: IPostApplicationStateTransitionPayload) => {
                if (!model.contract) {
                    if (!addFieldFileErrors.includes("required")) {
                        setAddFieldFileErrors([...addFieldFileErrors, "required"]);
                    }
                } else {
                    onSubmit(model);
                }
            }}
            validateOnChange
            validateOnBlur
        >
            {({ setFieldValue, values }) => (
                <Form
                    style={{
                        flexGrow: 1,
                        display: "flex",
                        flexDirection: "column",
                        padding: 24,
                        gap: 16
                    }}
                >
                    <p>{t("screen.dashboard.dialog.contractUpload")}</p>
                    <UploadField
                        name={t("screen.dashboard.dialog.contract")}
                        type="application/pdf"
                        onUploadFile={(file) => {
                            setFieldValue("contract", file);
                        }}
                        value={values.contract}
                        onDelete={() => {
                            setFieldValue("contract", null);
                        }}
                        sm={12}
                        onSetFileErrors={(newFileErrors) => {
                            setAddFieldFileErrors(newFileErrors);
                        }}
                    />
                    <div>
                        {addFieldFileErrors.map((fileError) => (
                            <HrBotErrorMessage key={uuidv4()} label={fileErrorToString("optionalFile", fileError)} />
                        ))}
                    </div>
                    <FormButtons
                        labelBack={t("screen.dataUpload.dialog.cancel")}
                        labelSubmit={t("screen.motivation.next")}
                        onBack={onBack}
                        style={{
                            justifyContent: "flex-end",
                            marginBottom: 0
                        }}
                    />
                </Form>
            )}
        </Formik>
    );
};
